import api from './api';

const athenaService = {
    listDatabases: ()               => api.get('/admin/athena/databases'),
    listTables:    (database)       => api.get('/admin/athena/tables', { params: { database } }),
    runQuery:      (data)           => api.post('/admin/athena/query', data),
    queryStatus:   (id, maxResults) => api.get('/admin/athena/query-status', { params: { id, maxResults } }),
};

export default athenaService;
